import type { LocaleMessageBundle } from '../../types'
import { hrmProfileMessages } from './hrm-profile'
import { staffMessages as staffFeatureMessages } from './staff'
import { staffShiftMessages } from './staff-shift'
import { payrollMessages } from './payroll'
import { contractMessages } from './contract'
import { offboardingMessages } from './offboarding'

export const staffMessages: LocaleMessageBundle = {
  vi: {
    ...staffFeatureMessages.vi,
    ...staffShiftMessages.vi,
    ...hrmProfileMessages.vi,
    ...payrollMessages.vi,
    ...contractMessages.vi,
    ...offboardingMessages.vi,
  },
  en: {
    ...staffFeatureMessages.en,
    ...staffShiftMessages.en,
    ...hrmProfileMessages.en,
    ...payrollMessages.en,
    ...contractMessages.en,
    ...offboardingMessages.en,
  },
}
